






































































































import {Component, Vue} from "vue-property-decorator";
import axios from "axios";
import {ReservationModel} from "@/model/reservation.model";
import {ReservationUtils} from "@/reservation-utils";
import {AxiosUtils} from "@/axios-utils";
import {CommonConstant} from "@/common-constant";
import {UserInfoForRegisterTmpModel} from "@/model/user-info/user-info-for-register-tmp.model";
import {UserInfoForRegisterModel} from "@/model/user-info/user-info-for-register.model";

@Component
    export default class Regist extends Vue {
        /** 共通ID表示名 */
        commonIdName: string = CommonConstant.COMMON_ID_NAME;

        model: UserInfoForRegisterTmpModel = new UserInfoForRegisterTmpModel;
        reservation: ReservationModel = new ReservationModel;

        // 登録ボタンの押下有無。登録ボタンが押下された場合はtrueにする。ボタンの活性制御に使用する
        isRegistered: boolean = false;

        activated() {
            // セッションからデータを取得
            this.model.copy(JSON.parse(sessionStorage.getItem("regist")));
            this.reservation = JSON.parse(sessionStorage.getItem("reservation"));
            // ボタンの活性制御フラグ
            this.isRegistered = false;
            this.$mount();
        }

        routeBack() {
            this.$router.back();
        }

        register() {
            // ボタンを非活性にする
            this.isRegistered = true;

            // 送信するデータを作成する
            // ※ CarInfoInputModel（this.model）にはマスタデータ等、送信に不要なデータがあるためCarInfoModelにコピー
            //    Object.assignだと不要なプロパティまでコピーされるので使用しない
            const userInfo = new UserInfoForRegisterModel();
            userInfo.copy(this.model.user as UserInfoForRegisterModel);
            userInfo.car.copy(this.model.car)

            // 会員情報の整形
            // 生年月日をフォーマット
            userInfo.birthday = userInfo.getBirthdayHyphenFormat();
            // プライバシーポリシーとサイトポリシーに同意するをセット
            userInfo.isCheckedAgree = this.model.isCheckedAgree
            // 送信前に会員情報をトリム
            userInfo.trim();

            // お車情報の整形
            // 前タイヤの各種値をセットする
            userInfo.car.setFrontTireValue(this.model.car.tireMaster.frontTireSizeList, this.model.car.carTypeMaster.carTypeDetails);
            // 後タイヤの各種値をセットする
            userInfo.car.setReaTireValue(this.model.car.tireMaster.reaTireSizeList, this.model.car.carTypeMaster.carTypeDetails);

            // 店舗コードが存在する場合（予約情報が取得できている場合）
            if (this.model.user.storeCode && this.model.user.storeCode != "") {
                // 会員情報の登録と予約情報の紐付けを行う。
                this.reservation.userInfo = userInfo; // 予約情報に会員情報を設定
                ReservationUtils.registerUserInfoAndlinkReservation(this.$router, this.reservation, () => {
                    this.$router.push("/client/regist-complete");
                })
            }
            // 上記以外の場合（通常時）
            else {
                // 会員情報を登録
                axios.post("/userinfo", userInfo)
                    // 成功の場合、完了画面に遷移
                    .then(() => {
                        this.$router.push("/client/regist-complete");
                    })
                    // エラーの場合
                    .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
            }
        }
    }
